import { useQuery } from "@tanstack/react-query"
import { IssueReportGet } from "../app/models/IssueReport"
import { digitalManagerApi } from "../services/api"

export function useIssueReports() {
  const { data: issueReportsList = [], isLoading: isLoadingIssueReports } = useQuery({
    queryKey: ["issueReports"],
    queryFn: () =>
      digitalManagerApi.get<IssueReportGet[]>(`/issueReports`).then((r) => r.data),
  })

  return {
    issueReportsList,
    isLoadingIssueReports,
  }
}
